import logo from '../Images/logo.png';
import favicon from '../Images/favicon.png';

const images = {
  logo,
  favicon
}

export default images;
